import * as React from 'react';

export const RebaReportIcon: React.FC = () => {
	return (
		<svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_382_28181)">
				<path
					d="M27.75 24.3485H6.25V4.25758C6.25 4.11591 6.1375 4 6 4H4.25C4.1125 4 4 4.11591 4 4.25758V26.4091C4 26.5508 4.1125 26.6667 4.25 26.6667H27.75C27.8875 26.6667 28 26.5508 28 26.4091V24.6061C28 24.4644 27.8875 24.3485 27.75 24.3485ZM9.55625 19.3805C9.65312 19.4803 9.80938 19.4803 9.90938 19.3805L14.2312 14.9502L18.2188 19.0843C18.3156 19.1841 18.475 19.1841 18.5719 19.0843L27.1781 10.2205C27.275 10.1206 27.275 9.95644 27.1781 9.85663L25.9406 8.58163C25.8936 8.53369 25.8302 8.5068 25.7641 8.5068C25.6979 8.5068 25.6345 8.53369 25.5875 8.58163L18.4 15.9837L14.4187 11.8561C14.3718 11.8081 14.3083 11.7812 14.2422 11.7812C14.1761 11.7812 14.1126 11.8081 14.0656 11.8561L8.32187 17.7384C8.27535 17.7869 8.24925 17.8522 8.24925 17.9204C8.24925 17.9885 8.27535 18.0539 8.32187 18.1023L9.55625 19.3805Z"
					fill="#262626"
				/>
			</g>
			<defs>
				<clipPath id="clip0_382_28181">
					<rect width="32" height="32" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
